/**
 * Segnali del menu del Magazzino (08 sez. 4, 15 sez. 3.1 punto 3): numero ambra dei Conflitti, pallino
 * rosso o ambra della Panoramica, pallino sull'icona nel menu collassato e sull'etichetta di un gruppo
 * chiuso. I valori arrivano da lib/commerce/menuRules.ts (menuBadge, strongestDot).
 */
import type { MenuBadge } from '../../../../lib/commerce/menuRules';

const DOT = { red: 'bg-[#E03E3E]', amber: 'bg-[#D9730D]' } as const;

export function MenuSignalBadge({ badge }: { badge: MenuBadge }) {
  if (!badge) return null;
  if (badge.kind === 'count') {
    return (
      <span className="ml-auto flex-shrink-0 text-[10px] font-semibold px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-400"
        aria-label={`${badge.value} da decidere`}>
        {badge.value > 99 ? '99+' : badge.value}
      </span>
    );
  }
  return <span className={`ml-auto flex-shrink-0 w-2 h-2 rounded-full ${DOT[badge.tone]}`} aria-label={badge.tone === 'red' ? 'Serve un intervento' : 'Da guardare'} />;
}

/** Pallino piccolo sovrapposto (icona nel menu collassato) o accanto a un'etichetta (gruppo chiuso). */
export function MenuDot({ tone, overlay = false }: { tone: 'red' | 'amber' | null; overlay?: boolean }) {
  if (!tone) return null;
  return (
    <span
      className={`${overlay ? 'absolute top-1 right-1' : 'inline-block ml-1.5'} w-1.5 h-1.5 rounded-full ${DOT[tone]}`}
      aria-label={tone === 'red' ? 'Serve un intervento' : 'Da guardare'}
    />
  );
}

export default MenuSignalBadge;
